<script>
import ApiErrorMixin from '@/mixins/apiErrorMixin'
import BankMixin from '@/mixins/bankMixin'
import { offerDate, offerTime } from '@/utils/dateUtl'
import { OFFICE_VIEW_ROUTE_NAME, ORGANIZATION_VIEW_ROUTE_NAME } from '@/router/client'

export const STATUS_DRAFT = 'draft'
const STATUS_CANCELED = 'canceled'
const STATUS_ACTIVE = 'active'
const STATUS_CASTING = 'casting'
const STATUS_DONE = 'done'
const STATUS_CLOSE = 'close'
const { LABORER_PERSONAL_VIEW_DATA_NAME } = require('@/router/laborer-personal-data')

export default {
  name: 'OfferViewMixin',
  mixins: [ApiErrorMixin, BankMixin],
  methods: {
    createRelay (offerInvitation) {
      // onOfferClick
      this.postRelay({
        'laborer': { 'id': offerInvitation.laborer.id },
      }, () => {
        this.onOfferClick({
          item: this.offer,
          value: true
        })
      })
    },
    setEndDate (data) {
      this.filters.dateTo = data
    },
    setStartDate (data) {
      this.filters.dateTo = null
      this.filters.dateFrom = data
    },
    formatDate (date, format = 'DD MMMM HH:mm') {
      return `${offerDate(date)} ${offerTime(date)}`
    },
    removeFilter () {
      this.removeRouterData({
        query: {
          sourceFile: undefined,
        }
      })
    },
    gotoLaborerPersonalData (id) {
      const routeData = this.$router.resolve({ name: LABORER_PERSONAL_VIEW_DATA_NAME, params: { id: id } })
      window.open(routeData.href, '_blank')
    },
    gotoOrganizationData (id) {
      const routeData = this.$router.resolve({ name: ORGANIZATION_VIEW_ROUTE_NAME, params: { id } })
      window.open(routeData.href, '_blank')
    },
    gotoOfficeData (id) {
      const routeData = this.$router.resolve({ name: OFFICE_VIEW_ROUTE_NAME, params: { id } })
      window.open(routeData.href, '_blank')
    },
    getTargetGenderLabel (targetGender) {
      if (targetGender === 'male') {
        return 'Мужской'
      }
      if (targetGender === 'female') {
        return 'Женский'
      }

      return null
    },
    getOfferAccessLevelLabel (offer) {
      if (offer.executor) {
        return 'Индивидуальный'
      }
      if (offer.isTeamAccessLevel) {
        return 'Для избранных'
      }
      if (offer.targetGender === 'male') {
        return 'только для мужчин'
      }

      if (offer.targetGender === 'female') {
        return 'Только для Женщин'
      }

      return 'Публичный'
    },
    getAccessLevel (item) {
      if (item.executor) {
        return 'Индивидуальный'
      }
      if (item.targetGender) {
        return item.targetGender === 'male' ? 'Мужской' : 'Женский'
      }
      if (item.isTeamAccessLevel) {
        return 'Для избранных'
      }

      return 'Публичный'
    },
    getStatus (status, deleted) {
      switch (status) {
      case STATUS_DRAFT:
        return `Будущий ${deleted ? '(Отменен)' : ''}`
      case STATUS_ACTIVE:
        return 'Активный'
      case STATUS_CASTING:
        return 'Смены'
      case STATUS_CANCELED:
        return 'Отменен'
      case STATUS_CLOSE:
      case STATUS_DONE:
        return 'Закрыть'
      default:
        return status
      }
    },
    isActiveOffer (offer) {
      return offer.status === STATUS_ACTIVE && !!offer.externalTaskId && parseInt(`${offer.externalTaskId}`) > 1
    },
  }
}
</script>
